import { CALL, EMAIL, MEETING } from 'customer-data-objects/engagement/EngagementTypes';
import { getProperty } from 'customer-data-objects/record/ObjectRecordAccessors';
import { LAST_TOUCH } from 'customer-data-objects/task/TaskPropertyNames';
import I18n from 'I18n';
// @ts-expect-error untyped
import FormattedDuration from 'I18n/components/FormattedDuration';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedName from 'I18n/components/FormattedName';
// @ts-expect-error untyped
import { TASK_LAST_TOUCH } from 'reference-resolvers/constants/ReferenceObjectTypes';
// @ts-expect-error untyped
import ResolveReferences from 'reference-resolvers/ResolveReferences';
// @ts-expect-error untyped
import { isError, isLoading } from 'reference-resolvers/utils';
import getIn from 'transmute/getIn';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { useOwnerId } from '../../hooks/auth';
import { jsx as _jsx } from "react/jsx-runtime";
function getEngagementPropertyValue(propertyName, lastTouchData) {
  return getIn(['referencedObject', 'engagement', 'properties', propertyName, 'value'], lastTouchData);
}
function getOwnerValue(ownerAttributeKey, lastTouchData) {
  return getIn(['referencedObject', 'owner', ownerAttributeKey], lastTouchData);
}
const ALLOWED_ENGAGEMENT_TYPES = [EMAIL, CALL, MEETING];
const getCurrentOwnerLastTouchI18nMessage = engagementType => {
  if (engagementType === EMAIL) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "tasks-table.cells.lastTouchText.youEmailed"
    });
  } else if (engagementType === CALL) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "tasks-table.cells.lastTouchText.youCalled"
    });
  } else {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "tasks-table.cells.lastTouchText.youMet"
    });
  }
};
const getOwnerLastTouchI18nMessage = (engagementType, givenName, familyName) => {
  if (engagementType === EMAIL) {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "tasks-table.cells.lastTouchText.ownerEmailed_jsx",
      options: {
        nameProps: {
          givenName,
          familyName
        }
      },
      elements: {
        Name: FormattedName
      }
    });
  } else if (engagementType === CALL) {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "tasks-table.cells.lastTouchText.ownerCalled_jsx",
      options: {
        nameProps: {
          givenName,
          familyName
        }
      },
      elements: {
        Name: FormattedName
      }
    });
  } else {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "tasks-table.cells.lastTouchText.ownerMet_jsx",
      options: {
        nameProps: {
          givenName,
          familyName
        }
      },
      elements: {
        Name: FormattedName
      }
    });
  }
};
const getFutureContactI18nMessage = engagementType => {
  if (engagementType === EMAIL) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "tasks-table.cells.lastTouchText.futureActivity.EMAIL"
    });
  } else if (engagementType === CALL) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "tasks-table.cells.lastTouchText.futureActivity.CALL"
    });
  } else {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "tasks-table.cells.lastTouchText.futureActivity.MEETING"
    });
  }
};
function LastTouchDescription({
  lastTouchTimestamp,
  lastTouchData
}) {
  const currentOwnerId = useOwnerId();
  if (isLoading(lastTouchData)) {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      size: "extra-small",
      use: "on-dark",
      layout: "inline",
      grow: true
    });
  }
  const engagementType = getEngagementPropertyValue('hs_engagement_type', lastTouchData);
  const lastTouchOwnerId = getOwnerValue('ownerId', lastTouchData);
  const ownerFirstName = getOwnerValue('firstName', lastTouchData);
  const ownerLastName = getOwnerValue('lastName', lastTouchData);
  const now = I18n.moment.userTz();
  const isInFuture = now.isBefore(lastTouchTimestamp);
  const isCurrentUserTheOwner = lastTouchOwnerId === currentOwnerId;
  const isOwnerNameValid = isCurrentUserTheOwner || ownerFirstName && ownerLastName;
  if (isError(lastTouchData) || !isOwnerNameValid) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "tasksAlerts.tableCellError"
    });
  }
  let lastTouchDescription = null;
  if (isInFuture && ALLOWED_ENGAGEMENT_TYPES.includes(engagementType)) {
    lastTouchDescription = getFutureContactI18nMessage(engagementType);
  } else if (isCurrentUserTheOwner && ALLOWED_ENGAGEMENT_TYPES.includes(engagementType)) {
    lastTouchDescription = getCurrentOwnerLastTouchI18nMessage(engagementType);
  } else if (ownerFirstName && ownerLastName && ALLOWED_ENGAGEMENT_TYPES.includes(engagementType)) {
    lastTouchDescription = getOwnerLastTouchI18nMessage(engagementType, ownerFirstName, ownerLastName);
  }
  return lastTouchDescription;
}
const mapResolversToProps = (resolvers, props) => {
  return {
    lastTouchData: resolvers[TASK_LAST_TOUCH].byId(props.task.objectId)
  };
};
const ResolvedLastTouchDescription = ResolveReferences(mapResolversToProps)(LastTouchDescription);
function LastTouchCell({
  original: task
}) {
  const timestamp = Number(getProperty(task, LAST_TOUCH));
  if (!timestamp) {
    return /*#__PURE__*/_jsx("div", {
      children: "--"
    });
  }
  return /*#__PURE__*/_jsx(UITooltip, {
    title: /*#__PURE__*/_jsx(ResolvedLastTouchDescription, {
      task: task,
      lastTouchTimestamp: timestamp
    }),
    children: /*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsx(FormattedDuration, {
        from: new Date(),
        to: new Date(timestamp),
        includeAffix: true
      })
    })
  });
}
export default LastTouchCell;